import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { resolveBaseUrl } from '../utils/api';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    let active = true;
    let newSocket = null;

    const setupSocket = async () => {
      const socketUrl = await resolveBaseUrl();
      if (!active) return;

      const tenantId = localStorage.getItem('ownerTenantId');
      newSocket = io(socketUrl, {
        transports: ['websocket', 'polling'],
        query: tenantId ? { tenant_id: tenantId } : undefined
      });

      newSocket.on('connect', () => {
        console.log('Socket connected:', newSocket.id);
      });

      newSocket.on('disconnect', () => {
        console.log('Socket disconnected');
      });

      setSocket(newSocket);
    };

    setupSocket();

    return () => {
      active = false;
      if (newSocket) {
        newSocket.close();
      }
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};




